import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { SxProps, Theme } from '@mui/system';

import Loader from '~images/loader.svg?react';
import Logo from '~images/logo_primary.svg?react';

const TREAD_LOGO_WHITE_URL = 'https://cdn.tread.io/tread-horizontal-white.svg';

interface CommonLoaderProps {
  sx?: SxProps<Theme>;
  text?: string;
}

export function CommonLoader({ sx, text }: CommonLoaderProps) {
  const isDarkMode = useTheme().palette.mode === 'dark';

  return (
    <>
      <Box
        sx={(theme) => ({
          position: 'absolute',
          top: 0,
          width: '100%',
          height: '100%',
          // Loading scrim; deep-black in dark mode so it doesn't flash white over
          // dark content (rgba of semantic.surface).
          backgroundColor:
            theme.palette.mode === 'dark'
              ? 'rgba(10, 24, 32, .5)'
              : 'rgba(255, 255, 255, .5)',
          zIndex: 10,
        })}
      />
      <Box sx={{ ...sx }}>
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            marginTop: 'calc(50vh - 120px)',
            textAlign: 'center',
            zIndex: 11,
          }}
        >
          {isDarkMode ? (
            <Box
              alt=""
              component="img"
              src={TREAD_LOGO_WHITE_URL}
              sx={{ height: 37, width: 189 }}
            />
          ) : (
            <Logo width={189} height={37} />
          )}

          <Box sx={{ mt: '40px' }}>
            <Loader width={200} height={25} />
          </Box>

          {text ? <Typography>{text}</Typography> : null}
        </Box>
      </Box>
    </>
  );
}
